/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-04-30 12:01:56
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * getOpenapiServerList
   * @description 公司管理列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getOpenapiServerList(data) {
    return request.post(`/${BASE_URL}/openapi_server/list`, data)
  },
  /**
   * saveCategory
   * @description 保存公司
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveOpenapiServer(data) {
    return request.post(`/${BASE_URL}/openapi_server/store`, data)
  },
  /**
   * getCategoryInfo
   * @description 获取公司详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getOpenapiServerInfo(id) {
    let data = {id:id}
    return request.post(`/${BASE_URL}/openapi_server/get_info`, data)
  },
  /**
   * deleteCategoryInfo
   * @description 删除公司
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteOpenapiServer(id) {
    let data = {id:id}
    return request.post(`/${BASE_URL}/openapi_server/delete`, data)
  },
  /**
   * @description 分类排序
   * @author YM
   * @date 2019-03-07
   * @param {*} ids
   * @returns
   */
  orderOpenapiServer(ids) {
    let data = {ids:ids}
    return request.post(`/${BASE_URL}/openapi_server/order`,data)
  },
  /**
   * @description 获取公司分类列表
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getOpenapiServerCategoryList() {
    return request.post(`/${BASE_URL}/openapi_server/category_list`)
  },
}